import companyLogo from '../../assets/LuxcartaLogo.png';

export const config = {
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:3000/api',
  companyName: process.env.REACT_APP_COMPANY_NAME || 'Default Company',
  companyLogo: companyLogo,
};
